<div class="layout-row align-end gap-2px responsive-column container m-t-20 m-b-20">
  <button mat-raised-button color="primary" [routerLink]="['../edit']">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="responsive-column">
        <h2 class="mat-h2 flex-100">{{ recurringDepositProduct.name }}</h2>

        <mat-divider [inset]="true"></mat-divider>

        <h3 class="mat-h3 flex-100">{{ 'labels.inputs.Details' | translate }}</h3>

        <mat-divider [inset]="true"></mat-divider>

        <div class="flex-100 layout-row">
          <span class="flex-40">{{ 'labels.inputs.Short Name' | translate }}:</span>
          <span class="flex-60">{{ recurringDepositProduct.shortName }}</span>
        </div>

        @if (recurringDepositProduct.description) {
          <div class="flex-100 layout-row">
            <span class="flex-40">{{ 'labels.inputs.Description' | translate }}:</span>
            <span class="flex-60">{{ recurringDepositProduct.description }}</span>
          </div>
        }

        <h3 class="mat-h3 flex-100">{{ 'labels.inputs.Currency' | translate }}</h3>

        <mat-divider [inset]="true"></mat-divider>

        <div class="flex-100 layout-row">
          <span class="flex-40">{{ 'labels.heading.Currency' | translate }}:</span>
          <span class="flex-60"
            >({{ recurringDepositProduct.currency.code }}) {{ recurringDepositProduct.currency.name }}</span
          >
        </div>

        <div class="flex-100 layout-row">
          <span class="flex-40">{{ 'labels.inputs.Decimal Places' | translate }}:</span>
          <span class="flex-60">{{ recurringDepositProduct.currency.decimalPlaces }}</span>
        </div>

        <div class="flex-100 layout-row">
          <span class="flex-40">{{ 'labels.inputs.Currency in multiples of' | translate }}:</span>
          <span class="flex-60">{{ recurringDepositProduct.currency.inMultiplesOf | formatNumber }}</span>
        </div>

        <h3 class="mat-h3 flex-100">{{ 'labels.heading.Terms' | translate }}</h3>

        <mat-divider [inset]="true"></mat-divider>

        <div class="flex-100 layout-row">
          <span class="flex-40">{{ 'labels.inputs.Deposit Amount' | translate }}:</span>
          <span class="flex-60">{{
            recurringDepositProduct.depositAmount +
              ' (Min: ' +
              (recurringDepositProduct.minDepositAmount
                ? recurringDepositProduct.minDepositAmount
                : recurringDepositProduct.depositAmount) +
              ', Max: ' +
              (recurringDepositProduct.maxDepositAmount
                ? recurringDepositProduct.maxDepositAmount
                : recurringDepositProduct.depositAmount) +
              ')'
          }}</span>
        </div>

        <div class="flex-100 layout-row">
          <span class="flex-40">{{ 'labels.inputs.Interest Compounding Period' | translate }}:</span>
          <span class="flex-60">{{ recurringDepositProduct.interestCompoundingPeriodType.value }}</span>
        </div>

        <div class="flex-100 layout-row">
          <span class="flex-40">{{ 'labels.inputs.Interest Posting Period' | translate }}:</span>
          <span class="flex-60">{{ recurringDepositProduct.interestPostingPeriodType.value }}</span>
        </div>

        <div class="flex-100 layout-row">
          <span class="flex-40">{{ 'labels.inputs.Interest Calculated using' | translate }}:</span>
          <span class="flex-60">{{ recurringDepositProduct.interestCalculationType.value }}</span>
        </div>

        <div class="flex-100 layout-row">
          <span class="flex-40">{{ 'labels.inputs.Days in Year' | translate }}:</span>
          <span class="flex-60">{{ recurringDepositProduct.interestCalculationDaysInYearType.value }}</span>
        </div>

        <h3 class="mat-h3 flex-100">{{ 'labels.heading.Settings' | translate }}</h3>

        <mat-divider [inset]="true"></mat-divider>

        @if (recurringDepositProduct.lockinPeriodFrequency) {
          <div class="flex-100 layout-row">
            <span class="flex-40">{{ 'labels.inputs.Lock-in Period' | translate }}:</span>
            @if (recurringDepositProduct.lockinPeriodFrequency !== undefined) {
              <span class="flex-60">
                {{ recurringDepositProduct.lockinPeriodFrequency }}
                {{ recurringDepositProduct.lockinPeriodFrequencyType.value }}</span
              >
            }
          </div>
        }

        @if (recurringDepositProduct.minDepositTerm) {
          <div class="flex-100 layout-row">
            <span class="flex-40">{{ 'labels.inputs.Minimum Deposit Term' | translate }}:</span>
            @if (recurringDepositProduct.minDepositTerm !== undefined) {
              <span class="flex-60"
                >{{ recurringDepositProduct.minDepositTerm }}
                &nbsp;
                {{ recurringDepositProduct.minDepositTermType.value }}</span
              >
            }
          </div>
        }

        @if (recurringDepositProduct.maxDepositTerm) {
          <div class="flex-100 layout-row">
            <span class="flex-40">{{ 'labels.inputs.Maximum Deposit Term' | translate }}:</span>
            @if (recurringDepositProduct.maxDepositTerm !== undefined) {
              <span class="flex-60"
                >{{ recurringDepositProduct.maxDepositTerm }}
                &nbsp;
                {{ recurringDepositProduct.maxDepositTermType.value }}</span
              >
            }
          </div>
        }

        @if (recurringDepositProduct.inMultipleOfDepositTerm) {
          <div class="flex-100 layout-row">
            <span class="flex-40">{{ 'labels.inputs.Deposit Term In multiple of' | translate }}:</span>
            @if (recurringDepositProduct.inMultipleOfDepositTerm !== undefined) {
              <span class="flex-60"
                >{{ recurringDepositProduct.inMultipleOfDepositTerm }}
                -
                {{ recurringDepositProduct.inMultipleOfDepositTermType.value }}</span
              >
            }
          </div>
        }

        @if (recurringDepositProduct.isMandatoryDeposit !== undefined) {
          <div class="flex-100 layout-row">
            <span class="flex-40">{{ 'labels.inputs.Recurring Deposit Type' | translate }}:</span>
            @if (recurringDepositProduct.isMandatoryDeposit) {
              <span class="flex-60">
                {{ 'labels.text.Mandatory' | translate }}
              </span>
            }
            @if (!recurringDepositProduct.isMandatoryDeposit) {
              <span class="flex-60">
                {{ 'labels.text.Voluntary' | translate }}
              </span>
            }
          </div>
        }

        @if (recurringDepositProduct.preClosurePenalInterest) {
          <div class="flex-100 layout-row">
            <span class="flex-40">{{ 'labels.inputs.Apply penal interest (less)' | translate }}:</span>
            <span class="flex-60"
              ><span class="m-r-5">{{ recurringDepositProduct.preClosurePenalInterest }}</span
              >%<span class="m-r-5">On</span>
              {{ recurringDepositProduct.preClosurePenalInterestOnType.value }}
            </span>
          </div>
        }

        <div class="flex-100 layout-row">
          <span class="flex-40">{{ 'labels.inputs.Withhold Tax is Applicable' | translate }}:</span>
          <span class="flex-60">{{ recurringDepositProduct.withHoldTax | yesNo }}</span>
        </div>

        @if (recurringDepositProduct.withHoldTax) {
          <div class="flex-100 layout-row">
            <span class="flex-40">{{ 'labels.inputs.Withhold Tax group' | translate }}:</span>
            <span class="flex-60">{{ recurringDepositProduct.taxGroup.name }}</span>
          </div>
        }

        @if (recurringDepositProduct.activeChart) {
          <div class="layout-row-wrap responsive-column flex-100">
            <h3 class="mat-h3 flex-100">{{ 'labels.heading.Interest Rate Charts' | translate }}</h3>
            <mat-divider [inset]="true"></mat-divider>
            <div class="layout-row-wrap responsive-column flex-100">
              @if (recurringDepositProduct.activeChart.name) {
                <div class="flex-100 layout-row">
                  <span class="flex-40">{{ 'labels.inputs.Name' | translate }}:</span>
                  <span class="flex-60">{{ recurringDepositProduct.activeChart.name }}</span>
                </div>
              }
              <div class="flex-100 layout-row">
                <span class="flex-40">{{ 'labels.inputs.Valid from Date' | translate }}:</span>
                <span class="flex-60">{{ recurringDepositProduct.activeChart.fromDate | dateFormat }}</span>
              </div>
              @if (recurringDepositProduct.activeChart.endDate) {
                <div class="flex-100 layout-row">
                  <span class="flex-40">{{ 'labels.inputs.End Date' | translate }}:</span>
                  <span class="flex-60">{{ recurringDepositProduct.activeChart.endDate | dateFormat }}</span>
                </div>
              }
              @if (recurringDepositProduct.activeChart.description) {
                <div class="flex-100 layout-row">
                  <span class="flex-40">{{ 'labels.inputs.Description' | translate }}:</span>
                  <span class="flex-60">{{ recurringDepositProduct.activeChart.description }}</span>
                </div>
              }
              <div class="flex-100 layout-row">
                <span class="flex-40">{{ 'labels.inputs.Primary Grouping by Amount' | translate }}:</span>
                <span class="flex-60">{{ recurringDepositProduct.activeChart.isPrimaryGroupingByAmount | yesNo }}</span>
              </div>
              <table
                class="mat-elevation-z1 flex-100"
                mat-table
                [dataSource]="recurringDepositProduct.activeChart.chartSlabs"
                multiTemplateDataRows
              >
                <ng-container matColumnDef="period">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Period' | translate }}</th>
                  <td mat-cell *matCellDef="let chartSlab">
                    @if (chartSlab.fromPeriod !== undefined) {
                      <div>{{ chartSlab.fromPeriod }} - {{ chartSlab.toPeriod }} {{ chartSlab.periodType.value }}</div>
                    }
                    @if (chartSlab.fromPeriod === undefined) {
                      <div>&nbsp;</div>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="amountRange">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Amount Range' | translate }}</th>
                  <td mat-cell *matCellDef="let chartSlab">
                    @if (chartSlab.amountRangeFrom !== undefined) {
                      <div>{{ chartSlab.amountRangeFrom }} - {{ chartSlab.amountRangeTo }}</div>
                    }
                    @if (chartSlab.amountRangeFrom === undefined) {
                      <div>&nbsp;</div>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="annualInterestRate">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Interest' | translate }}</th>
                  <td mat-cell *matCellDef="let chartSlab">
                    {{ chartSlab.annualInterestRate }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Description' | translate }}</th>
                  <td mat-cell *matCellDef="let chartSlab">
                    {{ chartSlab.description }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
                  <td mat-cell *matCellDef="let chartSlab; let chartSlabIndex = dataIndex">
                    <button
                      mat-button
                      color="primary"
                      (click)="expandChartSlabIndex = expandChartSlabIndex === chartSlabIndex ? null : chartSlabIndex"
                    >
                      @if (expandChartSlabIndex !== chartSlabIndex) {
                        <span>
                          <fa-icon icon="eye" class="m-r-10"></fa-icon>
                          {{ 'labels.buttons.View Incentives' | translate }}
                        </span>
                      }
                      @if (expandChartSlabIndex === chartSlabIndex) {
                        <span>
                          <fa-icon icon="eye-slash" class="m-r-10"></fa-icon>
                          {{ 'labels.buttons.Hide Incentives' | translate }}
                        </span>
                      }
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="incentives">
                  <td
                    mat-cell
                    *matCellDef="let chartSlab; let chartSlabIndex = dataIndex"
                    [attr.colspan]="chartSlabsDisplayedColumns.length"
                  >
                    <div
                      class="incentives flex-100 layout-row-wrap"
                      [@expandChartSlab]="chartSlabIndex === expandChartSlabIndex ? 'expanded' : 'collapsed'"
                    >
                      <mat-card class="layout-row-wrap flex-100">
                        <h4 class="mat-h4 flex-23">
                          {{ 'labels.heading.Incentives' | translate }}
                        </h4>
                        <table class="flex-100 mat-elevation-z1" mat-table [dataSource]="chartSlab.incentives">
                          <ng-container matColumnDef="entityType">
                            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Entity Type' | translate }}</th>
                            <td mat-cell *matCellDef="let incentive">
                              {{
                                incentive.entityType
                                  | find
                                    : recurringDepositProductTemplate.chartTemplate.entityTypeOptions
                                    : 'id'
                                    : 'value'
                              }}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="attributeName">
                            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Attribute Name' | translate }}</th>
                            <td mat-cell *matCellDef="let incentive">
                              {{
                                incentive.attributeName
                                  | find
                                    : recurringDepositProductTemplate.chartTemplate.attributeNameOptions
                                    : 'id'
                                    : 'value'
                              }}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="conditionType">
                            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Condition Type' | translate }}</th>
                            <td mat-cell *matCellDef="let incentive">
                              {{
                                incentive.conditionType
                                  | find
                                    : recurringDepositProductTemplate.chartTemplate.conditionTypeOptions
                                    : 'id'
                                    : 'value'
                              }}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="attributeValue">
                            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Attribute Value' | translate }}</th>
                            <td mat-cell *matCellDef="let incentive">
                              @switch (incentive.attributeName) {
                                @case (2) {
                                  <span>{{
                                    incentive.attributeValue
                                      | find
                                        : recurringDepositProductTemplate.chartTemplate.genderOptions
                                        : 'id'
                                        : 'name'
                                  }}</span>
                                }
                                @case (3) {
                                  <span>{{ incentive.attributeValue }}</span>
                                }
                                @case (4) {
                                  <span>{{
                                    incentive.attributeValue
                                      | find
                                        : recurringDepositProductTemplate.chartTemplate.clientTypeOptions
                                        : 'id'
                                        : 'name'
                                  }}</span>
                                }
                                @case (5) {
                                  <span>{{
                                    incentive.attributeValue
                                      | find
                                        : recurringDepositProductTemplate.chartTemplate.clientClassificationOptions
                                        : 'id'
                                        : 'name'
                                  }}</span>
                                }
                              }
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="incentiveType">
                            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Incentive Type' | translate }}</th>
                            <td mat-cell *matCellDef="let incentive">
                              {{
                                incentive.incentiveType
                                  | find
                                    : recurringDepositProductTemplate.chartTemplate.incentiveTypeOptions
                                    : 'id'
                                    : 'value'
                              }}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="amount">
                            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Amount' | translate }}</th>
                            <td mat-cell *matCellDef="let incentive">
                              {{ incentive.amount }}
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="incentivesDisplayedColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: incentivesDisplayedColumns"></tr>
                        </table>
                      </mat-card>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="chartSlabsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: chartSlabsDisplayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: chartSlabsIncentivesDisplayedColumns"
                  class="incentives-row"
                ></tr>
              </table>
              <mat-divider [inset]="true"></mat-divider>
            </div>
          </div>
        }

        @if (recurringDepositProduct.charges.length) {
          <div class="layout-row-wrap responsive-column flex-100">
            <h3 class="mat-h3 flex-100">{{ 'labels.heading.Charges' | translate }}</h3>
            <mat-divider [inset]="true"></mat-divider>
            <table class="flex-100 mat-elevation-z1" mat-table [dataSource]="recurringDepositProduct.charges">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Name' | translate }}</th>
                <td mat-cell *matCellDef="let charge">
                  {{ charge.name }}
                </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Type' | translate }}</th>
                <td mat-cell *matCellDef="let charge">
                  {{ charge.chargeCalculationType.value }}
                </td>
              </ng-container>
              <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Amount' | translate }}</th>
                <td mat-cell *matCellDef="let charge">
                  {{ charge.amount | formatNumber }}
                </td>
              </ng-container>
              <ng-container matColumnDef="collectedon">
                <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Collected On' | translate }}</th>
                <td mat-cell *matCellDef="let charge">
                  {{ charge.chargeTimeType.value }}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="chargesDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: chargesDisplayedColumns"></tr>
            </table>
          </div>
        }

        <h3 class="mat-h3 flex-100">{{ 'labels.heading.Accounting' | translate }}</h3>

        <mat-divider [inset]="true"></mat-divider>

        <LOSx-view-savings-accounting-details
          class="container"
          [accountingRule]="recurringDepositProduct.accountingRule"
          [accountingMappings]="recurringDepositProduct.accountingMappings"
        >
        </LOSx-view-savings-accounting-details>

        @if (
          recurringDepositProduct.paymentChannelToFundSourceMappings?.length ||
          recurringDepositProduct.feeToIncomeAccountMappings?.length ||
          recurringDepositProduct.penaltyToIncomeAccountMappings?.length
        ) {
          <div class="flex-100 layout-row-wrap layout-column.lt-md">
            <h3 class="mat-h3 flex-100">{{ 'labels.inputs.Advanced Accounting Rules' | translate }}</h3>
            <mat-divider [inset]="true"></mat-divider>
            @if (recurringDepositProduct.paymentChannelToFundSourceMappings?.length) {
              <div class="flex-100 layout-row-wrap layout-xs-column">
                <h4 class="mat-h4 flex-100">
                  {{ 'labels.inputs.Configure Fund Sources for Payment Channels' | translate }}
                </h4>
                <table
                  class="mat-elevation-z1 flex-100"
                  mat-table
                  [dataSource]="recurringDepositProduct.paymentChannelToFundSourceMappings"
                >
                  <ng-container matColumnDef="paymentTypeId">
                    <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Payment Type' | translate }}</th>
                    <td mat-cell *matCellDef="let paymentFundSource">
                      {{ paymentFundSource.paymentType.name }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="fundSourceAccountId">
                    <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Fund Source' | translate }}</th>
                    <td mat-cell *matCellDef="let paymentFundSource">
                      {{ paymentFundSource.fundSourceAccount.name }}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="paymentFundSourceDisplayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: paymentFundSourceDisplayedColumns"></tr>
                </table>
              </div>
            }
            @if (recurringDepositProduct.feeToIncomeAccountMappings?.length) {
              <div class="flex-100 layout-row-wrap layout-xs-column">
                <h4 class="mat-h4 flex-100">{{ 'labels.inputs.Fees to Specific Income Accounts' | translate }}</h4>
                <table
                  class="mat-elevation-z1 flex-100"
                  mat-table
                  [dataSource]="recurringDepositProduct.feeToIncomeAccountMappings"
                >
                  <ng-container matColumnDef="chargeId">
                    <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Fees' | translate }}</th>
                    <td mat-cell *matCellDef="let feesIncome">
                      {{ feesIncome.charge.name }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="incomeAccountId">
                    <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Income Account' | translate }}</th>
                    <td mat-cell *matCellDef="let feesIncome">
                      {{ feesIncome.incomeAccount.name }}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="feesPenaltyIncomeDisplayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: feesPenaltyIncomeDisplayedColumns"></tr>
                </table>
              </div>
            }
            @if (recurringDepositProduct.penaltyToIncomeAccountMappings?.length) {
              <div class="flex-100 layout-row-wrap layout-xs-column">
                <h4 class="mat-h4 flex-100">{{ 'labels.inputs.Penalties to Specific Income Accounts' | translate }}</h4>
                <table
                  class="mat-elevation-z1 flex-100"
                  mat-table
                  [dataSource]="recurringDepositProduct.penaltyToIncomeAccountMappings"
                >
                  <ng-container matColumnDef="chargeId">
                    <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Penalty' | translate }}</th>
                    <td mat-cell *matCellDef="let penaltyIncome">
                      {{ penaltyIncome.charge.name }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="incomeAccountId">
                    <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Income Account' | translate }}</th>
                    <td mat-cell *matCellDef="let penaltyIncome">
                      {{ penaltyIncome.incomeAccount.name }}
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="feesPenaltyIncomeDisplayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: feesPenaltyIncomeDisplayedColumns"></tr>
                </table>
              </div>
            }
          </div>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>
